var map = {
	"./GroupGo.webp": "./src/assets/dark/GroupGo.webp",
	"./home.webp": "./src/assets/dark/home.webp",
	"./homeGo.webp": "./src/assets/dark/homeGo.webp",
	"./more.webp": "./src/assets/dark/more.webp",
	"./noContent.webp": "./src/assets/dark/noContent.webp",
	"./search.webp": "./src/assets/dark/search.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/dark sync recursive ^\\.\\/.*\\.webp$";